import React from "react";
import { Card, FormCheck, FormControl } from "react-bootstrap";
import ConfirmDelete from "./ConfirmDelete";

interface IConfCampoBooleanProps {
  titulo: string;
  valorPadrao: boolean;
  obrigatorio: boolean;
  onDelete: () => void;
  onTitleChange: (titulo: string) => void;
  onValueChange: (valor: boolean) => void;
  onRequiredChange: (required: boolean) => void;
}

export function ConfCampoBoolean({
  titulo,
  valorPadrao,
  obrigatorio,
  onTitleChange,
  onValueChange,
  onRequiredChange,
  onDelete,
}: IConfCampoBooleanProps) {
  return (
    <Card>
      <Card.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Card.Title>Campo Booleano</Card.Title>
        <ConfirmDelete onDelete={onDelete} />
      </Card.Header>

      <Card.Body>
        <div className="mb-3">
          <label>Título</label>

          <FormControl
            value={titulo}
            onChange={(e) => onTitleChange(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label>Valor padrão</label>

          <FormCheck
            type="radio"
            name="valorPadraoBoolean"
            label="Sim"
            checked={valorPadrao}
            onChange={() => onValueChange(true)}
          />

          <FormCheck
            type="radio"
            name="valorPadraoBoolean"
            label="Não"
            checked={!valorPadrao}
            onChange={() => onValueChange(false)}
          />
        </div>

        <FormCheck
          type="checkbox"
          label="Obrigatório"
          checked={obrigatorio}
          onChange={(e) => onRequiredChange(e.target.checked)}
        />
      </Card.Body>
    </Card>
  );
}
